import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import FrontPageEnum from '../../enumerators/front-page.enum'

export default class SlidersComponent {
    constructor() {
        SlidersComponent.strateUnmissable()
        SlidersComponent.strateStay()
        SlidersComponent.strateBlog()
        SlidersComponent.strateAgenda()
    }

    static async strateUnmissable() {
        const strateUnmissableSlider = await Swiper.create(FrontPageEnum.STRATE_UNMISSABLE_SLIDER, {
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: FrontPageEnum.STRATE_UNMISSABLE_SLIDER_NAVIGATION_NEXT,
                prevEl: FrontPageEnum.STRATE_UNMISSABLE_SLIDER_NAVIGATION_PREV,
            },
            keyboard: false,
            spaceBetween: 12,
            slidesPerView: 1,
            lazy: true,
            loop: false,
            speed: 800,
            watchSlidesProgress: true,
            mousewheelControl: false,
            preventClicksPropagation: false,
            breakpoints: {
                551: {
                    slidesPerView: 2,
                },
                651: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    loop: true,
                },
                1001: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    loop: true,
                },
                1456: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    loop: true,
                },
            },
        })
    }

    static async strateStay() {
        const strateStaySlider = await Swiper.create(FrontPageEnum.STRATE_STAY_SLIDER, {
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: FrontPageEnum.STRATE_STAY_SLIDER_NAVIGATION_NEXT,
                prevEl: FrontPageEnum.STRATE_STAY_SLIDER_NAVIGATION_PREV,
            },
            keyboard: false,
            spaceBetween: 12,
            slidesPerView: 1,
            lazy: true,
            speed: 800,
            watchSlidesProgress: true,
            mousewheelControl: false,
            preventClicksPropagation: false,
            breakpoints: {
                651: {
                    spaceBetween: 30,
                },
                1001: {
                    spaceBetween: 30,
                },
                1456: {
                    spaceBetween: 40,
                },
            },
        })
    }

    static async strateBlog() {
        const strateBlogSlider = await Swiper.create(FrontPageEnum.STRATE_BLOG_SLIDER, {
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: FrontPageEnum.STRATE_BLOG_SLIDER_NAVIGATION_NEXT,
                prevEl: FrontPageEnum.STRATE_BLOG_SLIDER_NAVIGATION_PREV,
            },
            keyboard: false,
            spaceBetween: 12,
            slidesPerView: 1,
            lazy: true,
            speed: 800,
            watchSlidesProgress: true,
            mousewheelControl: false,
            preventClicksPropagation: false,
            breakpoints: {
                551: {
                    slidesPerView: 2,
                },
                651: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1001: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                1456: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
            },
        })
    }

    static async strateAgenda() {
        const strateAgendaSlider = await Swiper.create(FrontPageEnum.STRATE_AGENDA_SLIDER, {
            mousewheel: {
                forceToAxis: true,
            },
            navigation: {
                nextEl: FrontPageEnum.STRATE_AGENDA_SLIDER_NAVIGATION_NEXT,
                prevEl: FrontPageEnum.STRATE_AGENDA_SLIDER_NAVIGATION_PREV,
            },
            pagination: {
                el: FrontPageEnum.STRATE_AGENDA_SLIDER_DOTS,
                type: 'bullets',
                clickable: true,
            },
            keyboard: false,
            spaceBetween: 0,
            slidesPerView: 1,
            speed: 1000,
            watchSlidesProgress: true,
            mousewheelControl: false,
            preventClicksPropagation: false,
        })

        strateAgendaSlider.on('slideChange', () => {
            $(FrontPageEnum.STRATE_AGENDA_SLIDER_THUMBS_ITEM).removeClass('active')
            $(FrontPageEnum.STRATE_AGENDA_SLIDER_THUMBS)
                .find(`[data-index="${strateAgendaSlider.activeIndex}"]`)
                .addClass('active')
        })
    }
}
